export default "__VITE_ASSET__DpG1z4vD__"